import {Box, Link, Typography, useTheme} from '@mui/material';
import Image from 'next/image';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import ReactHtmlParser from 'react-html-parser';
import {faFileImage} from "@fortawesome/pro-duotone-svg-icons";
import MainContentProps from "@/src/_types/main-content-props";
import NextLink from 'next/link';

const MainContent = ({title, subtitle, img, url}: MainContentProps) => {
    const theme = useTheme();

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: 1,
        }}>
            {img ? (
                <Image
                    src={img}
                    height={124}
                    width={92}
                    alt={title}
                />
            ) : (
                <FontAwesomeIcon icon={faFileImage} size="8x" width={92} height={124}/>
            )}
            <Box>
                <Link
                    component={NextLink}
                    href={url ?? '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{textDecoration: 'none', color: 'inherit'}}
                >
                    <Typography
                        component="h3"
                        variant="fs5"
                        sx={{
                            display: '-webkit-box',
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            wordBreak: 'break-word',
                        }}>
                        {title}
                    </Typography>
                    <Typography
                        component="span"
                        variant="fs7"
                        sx={{
                            color: theme.palette.custom?.subtitleText,
                            fontSize: '12px',
                            display: '-webkit-box',
                            lineHeight: '1.25rem',
                            maxHeight: '3.75rem !important',
                            position: 'relative',
                            overflow: 'hidden',
                            '& p': {
                                m: 0,
                            },
                        }}
                    >
                        {ReactHtmlParser(subtitle)}
                    </Typography>
                </Link>
            </Box>
        </Box>
    );
};

export default MainContent;
